import {useStaticQuery, graphql} from 'gatsby';

const useSiteMeta = () => {
  const {dataYaml} = useStaticQuery(graphql`
    query SiteTitleQuery {
      dataYaml {
        siteUrl
        langDefault
        titleDefault
        siteName
        name
        address
        phone
        noStock
        noStockVariante
      }
    }
  `);
  return dataYaml;
};

export default useSiteMeta;
